import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";


const AboutSectionForHome = () => {

  const [about, setAbout] = useState([]);
  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/about`)
      .then((res) => res.json())
      .then((info) => setAbout(info));
  }, []);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);





  return (


    // <>

    //   {
    //     about.map(b => b.pageSlug === '' &&

    //       <section id="about-sec" className="content-2 wide-60 content-section division">
    //         <div className="container">
    //           <div className="row d-flex align-items-center">
    //             {/* IMAGE BLOCK */}
    //             <div className="col-md-5 col-lg-6">
    //               <div className="img-block left-column pc-25 mb-40 wow fadeInRight" data-wow-delay="0.4s">
    //                 <img className="img-fluid" src={b.aboutImgOne} alt="content-image" />
    //               </div>
    //             </div>
    //             {/* TEXT BLOCK */}
    //             <div className="col-md-7 col-lg-6">
    //               <div className="txt-block right-column pc-35 mb-40 wow fadeInLeft" data-wow-delay="0.4s">
    //                 {/* Title */}
    //                 <h3 className="h3-sm"> {b.aboutHeading}</h3>
    //                 {/* Text */}
    //                 <p className="grey-color">{b.aboutText}
    //                 </p>
    //                 {/* Text List */}
    //                 <ul className="txt-list grey-color">
    //                   <li className="list-item">
    //                     <i className="fas fa-angle-right" />
    //                     <p className="p-md">{b.pointOne}
    //                     </p>
    //                   </li>
    //                   <li className="list-item">
    //                     <i className="fas fa-angle-right" />
    //                     <p className="p-md">{b.pointTwo}
    //                     </p>
    //                   </li>
    //                   <li className="list-item">
    //                     <i className="fas fa-angle-right" />
    //                     <p className="p-md">{b.pointThree}
    //                     </p>
    //                   </li>
    //                 </ul>	{/* End Text List */}
    //               </div>
    //             </div>	{/* END TEXT BLOCK */}
    //           </div>	  {/* End row */}
    //         </div>     {/* End container */}
    //       </section>

    //     )}



    // </>

    <>


      {/* Ease of Search */}
      <section className="search-section">
        <div className="container">
          
          {/* Manage */}
          <div className="manage-section">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 order-md-1 order-2">
                <div className="manage_wrapper">
                  <figure className="mb-0 manage-sidecircle">
                    <img className="img-fluid" src="./assets/images/manage-sidecircle.png" alt />
                  </figure>
                  <figure className="mb-0 manage-phoneback">
                    <img src="./assets/images/manage-phoneback.png" alt />
                  </figure>
                  <figure className="mb-0 manage-phone2">
                    <img className="img-fluid" src="./assets/images/manage-phone2.png" alt />
                  </figure>
                  <figure className="mb-0 manage-phone1">
                    <img className="img-fluid" src="./assets/images/manage-phone1.png" alt />
                  </figure>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 order-md-2 order-1">
                <div className="manage_content" data-aos="fade-up">
                  <figure className="search-icon manage-icon">
                    <img src="./assets/images/manage-icon.png" alt className="img-fluid" />
                  </figure>
                  <h2>Manage Your Ad’s</h2>
                  <p>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod max me placeat facere possimus omnis.</p>
                  <p className="p-text">Assumenda est, omnis dolor repellendus temoriu autem quibusdam et aut officiis repudiandae sint molestiae non recusandae. </p>
                  <div className="manage-button">
                    <a className="try_free_btn" href="./contact.html">Try For Free</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSectionForHome;
